var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container step-counter"},[_c('p',[_vm._v(_vm._s(_vm.paso)+" de "+_vm._s(_vm.pasos))])])
}
var staticRenderFns = []

export { render, staticRenderFns }